export default "/fonts/vendor/@fortawesome/fontawesome-free/webfa-regular-400.svg?06b9d19ced8d17f3d5cbd5f1cbb31460";